module.exports = __webpack_public_path__ + "static/1-b4e7e1b32e962ed0aff70fedd40eb876.jpeg";